import { render } from "./ordonnanceListe.vue?vue&type=template&id=5bacf7df&scoped=true"
import script from "./ordonnanceListe.vue?vue&type=script&lang=js"
export * from "./ordonnanceListe.vue?vue&type=script&lang=js"

import "./ordonnanceListe.vue?vue&type=style&index=0&id=5bacf7df&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bacf7df"]])

export default __exports__